"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/table/style/css");
var table_1 = __importDefault(require("antd/lib/table"));
require("antd/lib/space/style/css");
var space_1 = __importDefault(require("antd/lib/space"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var icons_1 = require("@ant-design/icons");
var pages_1 = require("../../hooks/pages");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var FeedbackListView = /*#__PURE__*/ react_1.default.memo(function () {
    var loadingFeedback = (0, react_redux_1.useSelector)(function (state) {
        return state.feedback.isFetching;
    });
    var feedback = (0, react_redux_1.useSelector)(function (state) {
        return state.feedback.items;
    });
    var columns = (0, react_1.useMemo)(function () {
        return [{
                title: "Name",
                dataIndex: ["from", "name"]
            }, {
                title: "Email",
                dataIndex: ["from", "email"]
            }, {
                title: "Feedback",
                dataIndex: "content"
            }, {
                title: "Date",
                dataIndex: "submitted"
            }, {
                title: "Actions",
                key: "actions",
                render: function render() {
                    return (0, jsx_runtime_1.jsx)(space_1.default, {
                        size: "middle",
                        children: (0, jsx_runtime_1.jsx)(button_1.default, {
                            icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}),
                            danger: true,
                            disabled: true,
                            children: "Delete"
                        })
                    });
                }
            }];
    }, []);
    var pagination = (0, pages_1.useUrlPagination)();
    return (0, jsx_runtime_1.jsx)(page_header_1.default, {
        ghost: false,
        title: "Feedback",
        subTitle: "View user-submitted app feedback",
        children: (0, jsx_runtime_1.jsx)(table_1.default, {
            bordered: true,
            loading: loadingFeedback,
            columns: columns,
            dataSource: feedback,
            rowKey: "id",
            pagination: pagination
        })
    });
});
exports.default = FeedbackListView;
